const validator = (properties: Record<string, any>) => {
  const errors: string[] = [];

  const validEncodings = ['utf-8', 'utf-16', 'utf-16be', 'utf-32', 'ascii', 'iso-8859-1', 'windows-1252'];
  const validMimeTypes = [
    'text/plain',
    'text/html',
    'text/css',
    'text/javascript',
    'text/csv',
    'text/xml',
    'application/json',
    'application/xml',
    'application/octet-stream',
  ];

  if (properties.encoding && !validEncodings.includes(properties.encoding)) {
    errors.push(`Invalid encoding: ${properties.encoding}`);
  }

  if (properties.mimeType && !validMimeTypes.includes(properties.mimeType)) {
    errors.push(`Invalid MIME type: ${properties.mimeType}`);
  }

  return errors.length > 0 ? errors : null;
};

export default validator;
